import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  checkinAgreementData: {},
  isLoading: false,
  error: "",
  hasData: false,
  agreementStatus: {
    status: false,
    message: ""
  }
};
const checkinAgreementSlice = createSlice({
  name: "checkinAgreement",
  initialState,
  reducers: {
    agreementRequest: state => {
      state.isLoading = true;
    },
    checkinAgreementSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.checkinAgreementData = action.payload;
      state.agreementStatus.status = true;
    },
    checkinAgreementFailure: (state, action) => {
      state.error = action.payload;
      state.checkinAgreementData = "";
      state.isLoading = false;
      state.agreementStatus.status = false;
    }
  }
});
export const {
  agreementRequest,
  checkinAgreementSuccess,
  checkinAgreementFailure
} = checkinAgreementSlice.actions;
export default checkinAgreementSlice.reducer;